import script from "./EMenuItem.vue?vue&type=script&lang=ts&setup=true"
export * from "./EMenuItem.vue?vue&type=script&lang=ts&setup=true"

import "./EMenuItem.vue?vue&type=style&index=0&id=db7ff56e&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-db7ff56e"]])

export default __exports__